/**@jsxImportSource theme-ui */
import { Card } from '@theme-ui/components'
import React from 'react'

export default function MechanismPage() {
  return (
    <Card>
      <h1>Mekanisme Pelaporan Pelanggaran</h1>
      <p>
        Laporan dapat disampaikan melalui salah satu dari enam cara di bawah
        ini:
      </p>
      <div>
        <p>
          <strong>1. Web form online</strong>
        </p>
        <p>
          Laporan dapat dibuat secara online melalui link “
          <a href="/laporan-pengaduan/create">Buat Laporan</a>” yang terletak
          pada sisi tengah halaman atau klik{' '}
          <a href="/laporan-pengaduan/create">disini</a>
        </p>
        <p>
          <strong>2. SMS dan WhatsApp</strong>
        </p>
        <p>
          Anda dapat mengirimkan laporan menggunakan SMS dan WhatsApp ke nomor{' '}
          <a href="tel:+62 853-19000-150">+62 853-19000-150</a> atau nomor{' '}
          <a href="tel:+62 853-19000-253">+62 853-19000-253</a>&nbsp;Laporan
          melalui SMS atau WhatsApp akan diproses lebih lanjut dengan syarat
          berikut :
        </p>
        <ul>
          <li>Kronologi kejadian</li>
          <li>Tempat dan waktu kejadian</li>
          <li>Bukti seperti dokumen, foto, audio, video atau yang lainnya</li>
        </ul>
        <p>
          <strong>3. Telepon</strong>
        </p>
        <p>Pelaporan melalui telepon, dapat dilakukan melalui nomor:</p>
        <p>
          <a href="tel:+62 853-19000-150">+62 853-19000-150</a>&nbsp;
          <a href="tel:+62 853-19000-253">+62 853-19000-253</a>
        </p>
        <p>
          Saluran ini dibuka mulai pukul 08.30-17.30 pada hari kerja
          (senin-jumat) dan layanan voicemail diluar jam dan hari kerja.
        </p>
        <p>
          Anda akan terhubung dengan operator <strong>WBS</strong> yang akan
          menanyakan beberapa pertanyaan terkait tindakan dugaan penyimpangan.
        </p>
        <p>
          Pergunakan formulir yang telah disediakan, dan berikan informasi
          sebanyak mungkin mengenai dugaan pelanggaran yang terjadi.
        </p>
        <p>
          Pergunakan formulir yang telah disediakan.{' '}
          <a href="#">(Download formulir disini)</a>
        </p>
        <p>
          <strong>5. Email</strong>
        </p>
        <p>
          <strong>WBS</strong> menyediakan email untuk memudahkan Anda
          memberikan informasi sebanyak mungkin sehubungan dengan tindakan yang
          dilaporkan melalui alamat email ini :
        </p>
        <p>
          <strong>
            <a href="wbs@bpkh.go.id">wbs@bpkh.go.id</a>
            &nbsp;
          </strong>
          <a href="#">(Download formulir disini)</a>
        </p>
        <p>
          <em>
            Catatan: Untuk menjaga kerahasiaan identitas whistleblower, kami
            menyarankan Anda untuk menggunakan email pribadi (bukan email
            kantor/resmi) dalam pembuatan laporan.
          </em>
        </p>
        <p>
          <strong>6. Surat</strong>
        </p>
        <p>Anda dapat mengirimkan surat ke :</p>
        <ul>
          <li>WBS</li>
          <li>PO BOX 9999</li>
          <li>JKS 12010</li>
        </ul>
        <p>
          Pergunakan formulir yang telah disediakan.{' '}
          <a href="#">(Download formulir disini)</a>
        </p>
      </div>
    </Card>
  )
}
